import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Overlay, Popover} from 'react-bootstrap'

const StickyPopover = ({ component, children, placement, delay, onMouseEnter }) => {
    const [showPopover, setShowPopover] = useState(false);
    const childRef = useRef(null);
    let timeoutId;

    const handleMouseEnter = () => {
        timeoutId = setTimeout(() => {
            setShowPopover(true);
            if (onMouseEnter) {
                onMouseEnter();
            }
        }, delay);
    }

    const handleMouseLeave = () => {
        clearTimeout(timeoutId);
        setShowPopover(false);
    }

    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        }
    }, []);

    const child = React.Children.map(children, (child) =>
        React.cloneElement(child, {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: childRef
        })
    )[0];

    return (
        <>
            {child}
            <Overlay
                show={showPopover}
                placement={placement}
                target={childRef.current}
                shouldUpdatePosition={true}
            >
                <Popover
                    onMouseEnter={() => {
                        setShowPopover(true);
                    }}
                    onMouseLeave={handleMouseLeave}
                    id='popover'
                >
                    {component}
                </Popover>
            </Overlay>
        </>
    );
}

StickyPopover.defaultProps = {
    delay: 0,
    onMouseEnter: () => {}
}

StickyPopover.propTypes = {
    delay: PropTypes.number,
    onMouseEnter: PropTypes.func,
    children: PropTypes.element.isRequired,
    component: PropTypes.node.isRequired
}

export default StickyPopover;